export const phanLoaiSanPham = {
  sections: {
    list: { title: '商品分类' },
  },
  titles: { add: '新增分类', edit: '编辑分类' },
  columns: {
    summary: '分类名称',
    note: '备注',
    ngayTao: '创建时间',
    ngayCapNhat: '更新时间',
    status: '状态',
    onOffAction: '开关',
  },
  filter: {
    searchPlaceholder: '按分类名称搜索...',
    textDetailTitle: '详细筛选',
  },
  filters: {
    statusAll: '全部',
  },
  status: {
    dangHoatDong: '启用',
    ngungHoatDong: '停用',
  },
  messages: {
    loadError: '无法加载分类列表。',
    deleteSuccess: '已删除分类。',
    noData: '暂无分类。',
    listSummary: '共 {count} 项',
    saveSuccess: '已保存分类。',
    statusChanged: '已更新状态。',
    selectedCount: '已选 {count}',
    deleteSelected: '删除已选 ({count})',
    bulkDeleteConfirm: '删除已选的 {count} 个分类？',
    bulkDeleteSuccess: '已删除 {count} 个分类',
    bulkDeletePartial: '已删除 {ok}/{total}。{failed} 项无法删除。',
    bulkDeleteError: '批量删除失败',
    bulkDeleteNoneSelected: '尚未选择分类',
  },
  form: {
    tenPhanLoai: '分类名称',
  },
  validation: {
    tenRequired: '请输入分类名称。',
  },
}
